<template>
	<v-dialog v-if="abusable" scrollable persistent v-model="dialog" @click:outside="closeDialog()" @keyup.esc="closeDialog()" max-width="500">
		<v-card>
			<v-card-title>
				Zgłoś nadużycie
				<v-btn icon @click="closeDialog()" class="ml-auto">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<template v-if="!done">
				<v-card-text v-if="!fields.reason">
					<div>
						Wybierz powód zgłoszenia:
					</div>
					<v-list >
						<v-list-item v-for="(reason, index) in reasons" @click="setReason(reason)" :key="'reason-' + index" class="d-flex flex-row align-items-center reason mt-3 link">
							{{ reason.text }}
							<v-icon small class="ml-auto">mdi-arrow-right</v-icon>
						</v-list-item>
					</v-list>
				</v-card-text>
				<v-card-text v-else-if="fields.reason.isCustom">
					<div class="bold mb-3">
						Inny powód
					</div>
					<v-textarea
						v-model="fields.reason.text"
						placeholder="Opisz, co się stało..."
						outlined
						height="100"
						hide-details
						maxlength="1000"
						class="font-14"
					></v-textarea>
				</v-card-text>
				<v-card-text v-else>
					Czy zgłaszany przez Ciebie wpis zawiera <span class="bold">{{ fields.reason.text }}</span>, co narusza nasze standardy społeczności?
				</v-card-text>
			</template>
			<v-card-text v-else class="text-center my-auto py-4">
				<v-icon
					color="green"
					x-large
					class="success-icon"
				>mdi-check</v-icon>
				<div class="bold font-16 mt-3">Dziękujemy za zgłoszenie</div>
				<div class="mt-3 px-5">
					Teraz nasz zespół moderacyjny zapozna się z treścią przesłanego przez Ciebie zgłoszenia. Dostaniesz powiadomienie o zmianie statusu.
				</div>
			</v-card-text>
			<v-card-actions v-if="!done" class="justify-content-right text-right py-5 px-6">
				<div v-if="!done">
					<v-btn v-if="!fields.reason" @click="closeDialog()" elevation="0">Anuluj</v-btn>
					<v-btn v-else @click="back()" class="mr-2" elevation="0">Wstecz</v-btn>
					<v-btn v-if="fields.reason && !fields.reason.text" :disabled="!fields.reason" elevation="0"  color="accent">
						Dalej
					</v-btn>
					<v-btn v-else-if="fields.reason && fields.reason.text" @click="submit()" :loading="saving" color="accent" elevation="0">
						Zgłoś wpis
					</v-btn>
				</div>
			</v-card-actions>
			<v-card-actions v-else class="text-center justify-content-center py-3">
				<v-btn @click="closeDialog()" color="light" elevation="0">
					Zamknij
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from 'axios';
export default {
	props: {
		comment: {
			type: Object,
			default: null
		},
		post: {
			type: Object,
			default: null
		},
		problemIdea: {
			type: Object,
			default: null
		},
	},
	data() {
		return {
			done: false,
			dialog: true,
			saving: false,
			fields: {
				reason: null
			},
			reasons: [
				{
					text: 'Fałszywe informacje',
					isCustom: false
				},
				{
					text: 'Przemoc, prześladowanie, propagowanie nienawiści',
					isCustom: false
				},
				{
					text: 'Spam',
					isCustom: false
				},
				{
					text: 'Nie chcę tego widzieć',
					isCustom: false
				},
				{
					text: 'Inny powód',
					isCustom: true
				},
			]
		}
	},
	computed: {
		abusable() {
			if(this.post) {
				return {
					type: 'post',
					id: this.post.id
				}
			}

			else if(this.comment) {
				return {
					type: 'comment',
					id: this.comment.id
				}
			}
			else if(this.problemIdea) {
				return {
					type: 'problemIdea',
					id: this.problemIdea.id
				}
			}
			return null;
		}
	},
	methods: {
		setReason(reason) {
			if(reason) {
				this.fields.reason = Object.assign({}, reason);
				if(reason.isCustom) {
					this.fields.reason.text = '';
				}
			}
			else {
				this.fields.reason = null;
			}
			
		},
		closeDialog() {
			this.$emit('closed');
		},
		async submit() {
			this.saving = true;
			await axios.post('abuses', {
				abusable_type: this.abusable.type,
				abusable_id: this.abusable.id,
				reason: this.fields.reason.text
			})
			.then(() => {
				this.done = true;
			})
			.catch(error => {
				this.$snackbar.error({error});
			})
			this.saving = false;
		},
		showDialog() {
			this.dialog = true;
		},
		back() {
			this.setReason(null);
		}
	}
}
</script>

<style lang="scss" scoped>
	.reason {
		border: thin solid var(--v-grey-lighten2);
		border-radius: $border-radius-root;
		font-weight: bold;
	}
	.success-icon {
		background: var(--v-success-lighten3);
		padding: 20px;
		border-radius: 50%;
		width: 75px;
		height: 75px;
	}
</style>